import { useScreenWakeLock } from '@/lib/useScreenWakeLock.ts';
import {
  PracticeRealtimeCall,
  type PracticeRealtimeCallProps,
} from './PracticeRealtimeCall.tsx';

export type PracticeVoiceCallProps = PracticeRealtimeCallProps;

/**
 * A spoken practice conversation. The screen stays on for the whole call: a
 * laptop dimming mid-sentence is the browser's doing, not the call's.
 */
export function PracticeVoiceCall(props: PracticeVoiceCallProps) {
  useScreenWakeLock(!props.leaving);

  return <PracticeRealtimeCall {...props} />;
}
